import { ActionType } from '../store/actionTypes';
import {
  Action,
  ActionWithPlayload,
  ApiRequestPayload,
  CollectionQueryParams,
  Payload,
} from '../store/types';

const DEFAULT_PAGE_SIZE = 20;

export function createAction<T extends ActionType>(type: T): Action<T>;

export function createAction<T extends ActionType, P extends Payload = Payload>(
  type: T,
  payload: P,
): ActionWithPlayload<T, P>;

export function createAction<T extends ActionType, P>(type: T, payload?: P) {
  return payload === undefined ? { type } : { type, payload };
}

export function createApiRequestAction<T extends ActionType>(
  type: T,
  payload: ApiRequestPayload | (() => ApiRequestPayload),
) {
  return createAction(
    type,
    typeof payload === 'function' ? payload() : payload,
  );
}

export function pageToCollectionParams(
  page: number,
  pageSize?: number,
  sortBy?: string,
): CollectionQueryParams {
  pageSize = pageSize || DEFAULT_PAGE_SIZE;
  const offset = (page - 1) * pageSize;
  return {
    offset: Math.max(offset, 0),
    limit: pageSize,
    sortBy,
  };
}
